/** Size-optimized versions of several lodash functions  */

export const debounce = (func: (...args: any[]) => void, delay = 200) => {
  let timeout: ReturnType<typeof setTimeout> | undefined
  const cancel = () => clearTimeout(timeout)

  const debounced = function (this: any, ...args: any[]) {
    cancel()

    timeout = setTimeout(() => {
      timeout = undefined
      func.apply(this, args)
    }, delay)
  }

  debounced.cancel = cancel

  return debounced
}
